import { logError } from "../../../utils/devLog";

type PreDispatchMessageEvent = {
  timestamp: number;
  bankId: string;
  liftId: string;
  schemaFrontEndMessageJson: string;
  socketMessageLiftJson: string;
};

type PreDispatchMessageListener = (event: PreDispatchMessageEvent) => void;

const preDispatchMessageListeners = new Set<PreDispatchMessageListener>();

const socketEmitter = {
  emitPreDispatchMessage(event: PreDispatchMessageEvent) {
    preDispatchMessageListeners.forEach((listener) => {
      try {
        listener(event);
      } catch (error) {
        logError("[MonitoringWebSocketEmitter] Listener error:", error);
      }
    });
  },

  onPreDispatchMessage(listener: PreDispatchMessageListener) {
    preDispatchMessageListeners.add(listener);
  },

  offPreDispatchMessage(listener: PreDispatchMessageListener) {
    preDispatchMessageListeners.delete(listener);
  },
};

export type { PreDispatchMessageEvent };
export default socketEmitter;
